<template>
  <div class="layout2">
    <div class="title">{{ title }}</div>
    <div class="date">数据更新时间：{{ date }}</div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "当日总用电",
    },
    date: {
      type: String,
      default: "2020-10-20 15:21",
    },
  },
};
</script>
<style lang="less" scoped>
.layout2 {
  padding: 30px;
  box-sizing: border-box;
  background: #f8f8f9;
  width: 100%;
  height: 100%;
  box-shadow: 0px 0px 13px rgba(32, 47, 79, 0.09);
  position: relative;
  .title {
    font-size: 18px;
    color: #121c26;
    font-size: 18px;
    letter-spacing: 4px;
    font-weight: 600;
    text-align: left;
  }
  .date {
    position: absolute;
    right: 50px;
    top: 30px;
    color: #344e72;
    font-size: 14px;
  }
}
</style>